import React, { useState } from "react";
import { Form, Input, InputNumber, Button, Row, Col, notification } from "antd";
import {
  TagOutlined,
  EnvironmentOutlined,
  PhoneOutlined,
} from "@ant-design/icons";
import { addTeacherCollabApi } from "../../../../api/teacherCollab";
import { getAccessToken } from "../../../../api/auth";

import "./AddTeacherCollabForm.scss";

export default function AddTeacherCollabForm(props) {
  const { setIsVisibleModal, setReloadTeacherCollabs } = props;

  const [inputs, setInputs] = useState({
    teachercollab_code: "",
    description: "",
  });

  const [disabledSubmit, setDisabledSubmit] = useState(false);

  const isFormValid = (e) => {
    //console.log(inputs);
    let errorExists = false;
    if (!inputs.description) {
      notification["error"]({
        message: "Obligatorio: descripción.",
      });
      errorExists = true;
    }
    return errorExists;
  };

  const addTeacherCollab = async (e) => {
    e.preventDefault();

    if (!isFormValid()) {
      if(!disabledSubmit){
        setDisabledSubmit(true);
        const accessToken = getAccessToken();

        await addTeacherCollabApi(accessToken, inputs)
          .then((response) => {
            if (
              response === "ERR_CONNECTION_REFUSED" ||
              response === "Failed to fetch" ||
              response === undefined
            ) {
              notification["error"]({
                message: "Servidor caido",
              });
              disabledSubmit(false);
            } else if (response.code !== 200) {
              notification["error"]({
                message: response.message,
              });
              disabledSubmit(false);
              setReloadTeacherCollabs(true);
            } else {
              notification["success"]({
                message: "Colaborador Docente creado/a",
              });
              setIsVisibleModal(false);
              setReloadTeacherCollabs(true);
            }
            //setReloadTeacherCollabs(true);
          })
          .catch((err) => {
            notification["error"]({
              message: err,
            });
          });
      }
    }
  };

  return (
    <div className="add-teachercollab-form">
      <AddForm
        inputs={inputs}
        setInputs={setInputs}
        addTeacherCollab={addTeacherCollab}
      />
    </div>
  );
}

function AddForm(props) {
  const { inputs, setInputs, addTeacherCollab } = props;

  return (
    <Form className="form-add" onSubmit={addTeacherCollab}>
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col span={12}>
          <label className="control-label">
            Código
          </label>
          <Form.Item>
            <InputNumber
              prefix={<TagOutlined />}
              placeholder="Automático"
              value={inputs.teachercollab_code}
              onChange={(e) => setInputs({ ...inputs, teachercollab_code: e })}
              style={{ width: "100%" }}
              disabled={true}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <label className="control-label">
            <span className="control-required">*</span> Descripción
          </label>
          <Form.Item>
            <Input
            //   placeholder="descripcion"
              value={inputs.description}
              onChange={(e) => setInputs({ ...inputs, description: e.target.value })}
            />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item>
        <Button
          type="primary"
          htmlType="submit"
          className="btn-submit"
          onClick={addTeacherCollab}
        >
          Crear
        </Button>
      </Form.Item>
    </Form>
  );
}
